import React, { Component, ReactNode } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Logo from "../Logo";
import NextRouteURLs from "NextRouteURLs";
import RouteURLs from "RouteURLs";
import "./index.scss";

type RouteUrlsType = typeof RouteURLs[keyof typeof RouteURLs];
interface NavItemProps {
  title: string;
  route: RouteUrlsType;
}

interface DashboardHeaderProps extends RouteComponentProps {
  navItems: NavItemProps[];
  children?: ReactNode;
}

class DashboardHeader extends Component<DashboardHeaderProps> {
  onNavClick = (route: RouteUrlsType) => {
    this.props.history.push(route);
  };

  render() {
    return (
      <header className="dashboard">
        <div className="content">
          <div className="logo">
            <a href={NextRouteURLs.HOME}>
              <Logo />
            </a>
          </div>
          <div className="titles">
            {this.props.navItems.map((navItem) => (
              <span
                className="title"
                onClick={() => this.onNavClick(navItem.route)}
              >
                {navItem.title}
              </span>
            ))}
          </div>
          <span className="items">{this.props.children}</span>
        </div>
      </header>
    );
  }
}

export default withRouter(DashboardHeader);
